import { FieldType, SystemFieldType } from './types';

export const mapItemFieldIdToFieldId = (itemFieldId: FieldType | 'status') => {
	if (itemFieldId === SystemFieldType.barcode) return 'barcodes';
	if (itemFieldId === SystemFieldType.qr) return 'codes';
	if (itemFieldId === SystemFieldType.rfid) return 'rfidcodes';
	if (itemFieldId === SystemFieldType.kit) return 'kit.name';
	if (itemFieldId === SystemFieldType.category) return 'category.name';
	if (itemFieldId === SystemFieldType.location)
		return 'location.name,location.icon,location.rootLocation,locationPath,locationPath.name,locationPath.icon';
	if (itemFieldId === SystemFieldType.custody) return 'custody._id,custody.name,order.customer.name';
	if (itemFieldId === 'fields.*') return 'fields.*,fields.*.name,fields.*.locationPath.name';
	if (itemFieldId === 'status') return 'status,canReserve,canOrder';
	return itemFieldId;
};
